import { addMessageBox } from './messageBoxesActions';
export const GO_TO_PAGE = 'GO_TO_PAGE';
export const GO_BACK = 'GO_BACK';
export const GO_FORWARD = 'GO_FORWARD';
function goToGameGuidePage(page) {
    return {
        type: GO_TO_PAGE,
        payload: page
    };
}
export function thunkGoToGameGuidePage(page = 'home') {
    return function (dispatch, getState) {
        const state = getState();
        if (!state.messageBoxes.messageBoxes.length ||
            state.messageBoxes.messageBoxes[state.messageBoxes.messageBoxes.length - 1].type !== 'game-guide') {
            // need to open game guide message box
            dispatch(addMessageBox({ type: 'game-guide' }));
        }
        dispatch(goToGameGuidePage(page));
    };
}
export function goBackInGameGuide() {
    return {
        type: GO_BACK
    };
}
export function goForwardInGameGuide() {
    return {
        type: GO_FORWARD
    };
}
